import React from 'react'
import { SwitchDesignBtn } from '../components/user/HomepageStarterEmail/styled'
import { HiOutlineSwitchHorizontal } from 'react-icons/hi'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { BASE_SET_NEW_DESIGN } from '../redux/types/base'

export const useSwitchDesign = () => {
	const { isNewDesign } = useSelector(state => state.base)
	const dispatch = useDispatch()
	// ? Custom css styles, if 'isNewDesign'
	let altErrorStyle = {}
  if (isNewDesign) {
    altErrorStyle = {
      display: 'block',
      color: '#FF7171',
      backgroundColor: 'rgba(255, 113, 113, 0.12)',
      borderLeft: '3px solid #FF7171',
      padding: '2px 8px',
      borderRadius: '6px',
      fontSize: '0.875em',
      fontWeight: 500,
      marginTop: '2px',
      marginBotton: '0px',
      width: 'fit-content',
      textAlign: 'left',
      position: 'static'
    }; 
  }

	const switchDesign = () => {
		dispatch({
			type: BASE_SET_NEW_DESIGN,
			payload: !isNewDesign
		})
	}
	
	const switchBtn = (
		<SwitchDesignBtn onClick={switchDesign}>
			<HiOutlineSwitchHorizontal />
		</SwitchDesignBtn>
	)

  return {
		isNewDesign,
		switchDesign,
		switchBtn,
		altErrorStyle
  }
}

